import { datadogRum } from '@datadog/browser-rum';

/**
 * Custom error tracker that will send custom errors to DataDog
 *
 * @param eventName
 * @param options
 */

export const reportError = (
  error: unknown,
  eventName: string,
  eventData?: { [key: string]: any }
): void => {
  datadogRum.addError(error, {
    eventName,
    ...eventData,
  });
};
